import styled, { css } from 'styled-components';

import { RowProps } from './Row';
import { flexGap } from '../../../utils/flexGap';

export const RowContainer = styled.div<RowProps>`
	${({
		$gap,
		$reverse,
		$hcenter,
		$vcenter,
		$spaceBetween,
		$spaceAround,
		$fillSpace,
		$fillHeight,
		$align,
	}) => css`
		display: flex;
		flex-direction: row;
		${$gap && flexGap(`${$gap}px`, true)}
		gap: ${$gap}px;
		${$align && `align-items: ${$align}`};
		${$hcenter && 'justify-content: center'};
		${$vcenter && 'align-items: center'};
		${$spaceAround && 'justify-content: space-around'};
		${$spaceBetween && 'justify-content: space-between'};
		${$reverse && 'flex-flow: row-reverse'};
		${$fillSpace && 'width: 100%'};
		${$fillHeight && 'height: 100%'};
	`}
`;
